import React, { useState } from "react";
import "./Footer.css";
import {
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaTwitter,
} from "react-icons/fa6";
import { Link } from "react-router-dom";
import BookingFormModal from "./BookingFormModal";
const Footer = () => {
   const [active, setActive] = useState(false);
    const [serviceActive, setServiceActive] = useState(false);
  
    const [activeModal, setActiveModal] = useState(false);
    const [activeClass, setActiveClass] = useState(0);
  
    const [isOpen, setIsOpen] = useState(false);
    const [isSticky, setIsSticky] = useState(false);
    // const [active, setIsActive] = useState(false);
  
    const handleMenuClick = () => {
      setIsOpen(!isOpen);
      setActive(!active);
    };
  
    // const handleScroll = () => {
    //   setIsSticky(window.scrollY > 40);
    // };
  
    // useEffect(() => {
    //   window.addEventListener("scroll", handleScroll);
    //   return () => {
    //     window.removeEventListener("scroll", handleScroll);
    //   };
    // }, []);
    const [showModal, setShowModal] = useState(false);
  
    const handleOpenModal = () => setShowModal(true);
    const handleCloseModal = () => setShowModal(false);
    const handleBookAppointments = () => {
      setActiveModal(!activeModal);
    };
    const handleBookAppointment = () => {
      setActiveModal(!activeModal);
      setActive(false);
    };
  return (
    <div>
      <footer className="footer ttm-bg ttm-bgcolor-darkgrey widget-footer clearfix">
        <div className="container">
          <div className="first-footer">
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-9 widget-area">
                <div className="widget widget_text clearfix">
                  <div className="d-sm-flex align-items-center">
                    <div className="footer-logo">
                      <img
                        width={190}
                        height={160}
                        id="footer-logo-img"
                        className="img-fluid"
                        src="/Images/footer-logo.png"
                        alt="image"
                        style={{ width: "150px", height: "150px" }}
                      />
                    </div>
                    <div className="textwidget widget-text">
                      <p>
                        Surgery Saath offers expert surgical care across
                        locations in{" "}
                        <b style={{ color: "#fff" }}>
                          Sector 43 Gurgaon, Delhi Cantonment, and Indirapuram
                          Ghaziabad, Noida
                        </b>{" "}
                        prioritizing patient safety and personalized treatment
                        for optimal outcomes.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-3 widget-area">
                <div className="widget widget_social clearfix">
                  <div
                    className="social-icons text-lg-right"
                    style={{ padding: "45px 0px" }}
                  >
                    <ul className="social-icons list-inline">
                      <li className="social-facebook">
                        <Link
                          className="tooltip-top"
                          to="https://www.facebook.com/share/186Hhz2LZt/"
                          target="_blank"
                        >
                          <FaFacebook
                            className="fa fa-facebook"
                            aria-hidden="true"
                            color="#fff"
                          />
                        </Link>
                      </li>
                      <li className="social-linkedin">
                        <Link
                          className="tooltip-bottom"
                          target="_blank"
                          data-tooltip="LinkedIn"
                          rel="noopener"
                          aria-label="linkedin"
                        >
                          <FaLinkedin
                            className="fa fa-linkedin"
                            aria-hidden="true"
                            color="#fff"
                          />
                        </Link>
                      </li>
                      <li className="social-twitter">
                        <Link
                          className="tooltip-top"
                          target="_blank"
                          data-tooltip="Twitter"
                          rel="noopener"
                          aria-label="twitter"
                        >
                          <FaTwitter
                            className="fa fa-twitter"
                            aria-hidden="true"
                            color="#fff"
                          />
                        </Link>
                      </li>
                      <li className="social-pinterest">
                        <Link
                          className="tooltip-bottom"
                          to="https://www.instagram.com/surgerysaathi?igsh=dnQ0YTBub2RxZHd4"
                          target="_blank"
                        >
                          <FaInstagram
                            className="fa fa-pinterest-p"
                            aria-hidden="true"
                            color="#fff"
                          />
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="second-footer">
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-5 widget-area">
                <div className="widget widget_text clearfix">
                  <h3 className="widget-title">
                    Your Journey to a More Confident You!
                  </h3>
                  <div className="textwidget widget-text">
                    <p>
                      Our Mission is to Provide the Best Surgical Care for
                      Patients Around the World!
                    </p>
                  </div>
                  <div
                    className="widget-footer-button"
                    onClick={handleBookAppointments}
                  >
                    <Link
                      className="ttm-btn ttm-btn-size-sm ttm-btn-shape-squar ttm-btn-style-fill ttm-icon-btn-right ttm-btn-color-skincolor mt-25 res-767-mb-30"
                      style={{ border: "1px solid white" }}
                    >
                      Book An Appointment
                    </Link>
                  </div>
                </div>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-6 col-lg-7 widget-area pl-120 res-991-pl-15">
                <div className="widget widget_nav_menu clearfix">
                  <ul id="menu-footer-service-link" className="menu">
                    <li>
                      <Link to="/">Home</Link>
                    </li>
                    <li>
                      <Link to="/about-us">About Company</Link>
                    </li>
                    <li>
                      <Link to="/lipoma-removal">Lipoma Removal</Link>
                    </li>
                    <li>
                      <Link to="/rhinoplasty">Rhinoplasty</Link>
                    </li>
                    <li>
                      <Link to="/gynaecomastia">Gynaecomastia</Link>
                    </li>
                    <li>
                      <Link to="/ophthalmology">Ophthalmology</Link>
                    </li>
                  </ul>
                  <div className="row">
                    <div className="widget-area col-xs-12 col-sm-12 col-md-12 col-lg-6">
                      {/*featured-icon-box*/}
                      <div className="featured-icon-box icon-align-before-content style15">
                        <div className="featured-icon">
                          <div className="ttm-icon ttm-icon_element-onlytxt ttm-icon_element-color-skincolor ttm-icon_element-size-md">
                            <img
                              src="https://cdn-icons-png.freepik.com/512/4039/4039153.png"
                              style={{
                                height: "70px",
                                width: "70px",
                                marginBottom: "0px",
                              }}
                              className="flaticon flaticon-phone-call-1"
                            />
                          </div>
                        </div>
                        <div className="featured-content">
                          <div className="featured-desc">
                            <p>Talk to an Experts</p>
                            <p>
                              Toll Free <span>+918882852726</span>
                            </p>
                          </div>
                        </div>
                      </div>
                      {/* featured-icon-box end*/}
                    </div>
                    <div className="widget-area col-xs-12 col-sm-12 col-md-12 col-lg-6">
                      {/*featured-icon-box*/}
                      <div className="featured-icon-box icon-align-before-content style15">
                        <div className="featured-icon">
                          <div className="ttm-icon ttm-icon_element-onlytxt ttm-icon_element-color-skincolor ttm-icon_element-size-md">
                            <img
                              src="https://cdn-icons-png.freepik.com/512/5907/5907625.png"
                              style={{
                                width: "60px",
                                height: "60px",
                                marginBottom: "0px",
                              }}
                              className="flaticon flaticon-email-2"
                            />
                          </div>
                        </div>
                        <div className="featured-content">
                          <div className="featured-desc">
                            <p>Have Any Questions</p>
                            <p>
                              Mail{" "}
                              <span>
                                <Link
                                  href="mailto:info@surgerysaathi.com"
                                  style={{ color: "#fff" }}
                                >
                                  {" "}
                                  info@surgerysaathi.com{" "}
                                </Link>
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                      {/* featured-icon-box end*/}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="bottom-footer-text">
            <div className="row copyright">
              <div className="col-lg-7 col-md-7 col-sm-12">
                <span>
                  Copyright © 2024&nbsp;
                  <Link
                    href="https://themetechmount.com/html/inoterior/demo3/"
                    className="ttm-textcolor-white"
                  >
                    Surgery Saathi&nbsp;
                  </Link>{" "}
                  . All rights reserved.
                </span>
              </div>
              <div className="col-lg-5 col-md-5 col-sm-12">
                <div
                  id="footer-nav-menu"
                  className="d-flex flex-row justify-content-end"
                >
                  <ul className="footer-nav-menu" style={{ color: "#fff" }}>
                    <li>
                      <Link to="/about-us">About Us</Link>
                    </li>
                    <li>
                      <Link to="rhinoplasty">Services</Link>
                    </li>
                    <li>
                      <Link to="/contact-us">Contact Us</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      {activeModal ? (
        <BookingFormModal active={activeModal} setActive={setActiveModal} />
      ) : (
        ""
      )}
    </div>
  );
};

export default Footer;
